<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <div style="display:flex;">
          <a-row class="left" style="flex:1">
            <a-col :span="24">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型" prop="devClassCode">
                <j-tree-select-custom
                  :disabled="deviceModelDisadbled"
                  :getPopupContainer="getModalAsContainer"
                  :multiple="false"
                  column="dev_class_code"
                  dict="`iwt-wf`.dev_class,type_name,id"
                  hasChildField="has_child"
                  order="sort_no asc"
                  pidValue="-1"
                  placeholder="请选择设备类型"
                  ref="treeSelect"
                  returnKey="dev_class_code"
                  v-model="model.devClassCode"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号名称" prop="modelName">
                <a-input placeholder="请输入型号名称" v-model="model.modelName"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号编码" prop="modelCode">
                <a-input placeholder="请输入型号编码" v-model="model.modelCode"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="right" style="flex:1">
            <a-col :span="24">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label prop="pictureObjId">
                <j-image-upload bizPath="scott/pic" v-model="model.pictureObjId"></j-image-upload>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运行寿命(天)" prop="runningLife">
              <a-input-number placeholder="请输入运行寿命(天)" style="width: 100%" v-model="model.runningLife" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产厂家" prop="manuId">
              <j-search-select-tag
                :getPopupContainer="getModalAsContainer"
                @change="modeAddEnd"
                dict="`iwt-wf`.common_manufacturer,manu_name,id, 1=1 order by manu_name asc"
                placeholder="请选择生产厂家"
                v-if="manuTypeShow"
                v-model="model.manuId"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <DevModelTab
      :disabled="formDisabled"
      :model="model"
      :modelId="modelId"
      :modelName="model.modelName"
      v-if="modelId"
    />
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  // import DTable from '@/views/eMaintenance/components/MaintenanceTable.vue'
  import DevModelTab from '../DevModelTab'
  // import JSBCDemo from '@/views/jeecg/JVxeDemo/layout-demo/Index.vue'

  export default {
    name: 'DevModelForm',
    components: {
      DevModelTab
    },
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          modelName: [{ required: true, message: '请输入型号名称!' }],
          modelCode: [{ required: true, message: '请输入型号编码!' }]
        },
        manuList: [],
        devClassList: [],
        url: {
          add: '/device/devModel/add',
          edit: '/device/devModel/edit',
          queryById: '/device/devModel/queryById',
          commonManufacturer: '/device/commonManufacturer/selectDropList',
          devClass: '/device/devClass/selectDropList'
        },
        manuTypeShow: true,
        deviceModelDisadbled: false,
        modelId: ''
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      getAction(this.url.commonManufacturer).then(res => {
        this.manuList = res.result.records
      })
      getAction(this.url.devClass).then(res => {
        this.devClassList = res.result.records.map(item => {
          return {
            value: item.id,
            label: item.typeName
          }
        })
      })
    },
    methods: {
      add () {
        this.edit(this.modelDefault)
        this.deviceModelDisadbled = false
      },
      async edit (record) {
        if (record.id && !record.modelName) {
          record = await getAction(this.url.queryById, record)
          record = record.result
        }
        this.model = Object.assign({}, record)
        this.modelId = record.id
        this.deviceModelDisadbled = true
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(async valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            const { success, message, result } = await httpAction(httpurl, this.model, method)
            if (success) {
              that.$message.success(`${that.model.id ? '编辑' : '添加'}成功`)

              that.confirmLoading = false
              // if (!that.modelId) {

              //   return
              // }

              if (result && !that.model.id) {
                that.$parent.title = '编辑'
                that.model.id = result
                that.modelId = result
                return
              }
              that.$emit('ok', { id: result, modelName: this.model.modelName })
            } else {
              that.$message.warning(message)
            }
            that.confirmLoading = false
          }
        })
      },
      modeAddEnd (id) {
        this.manuTypeShow = false
        this.model.manuId = id
        this.manuTypeShow = true
      },
      getModalAsContainer (node) {
        return document.querySelector('.j-modal-box .ant-modal-content')
      }
    }
  }
</script>
